<template>
  <section id="primesalud-price-cards" class="my-5 py-5 px-3 open-salud-prices">
    <div class="d-flex flex-column justify-center">
      <h3>{{ title }}</h3>
      <p class="subtitle">{{ subtitle }}</p>
      <p class="main-text">{{ content }}</p>
      <p class="main-text">{{ subcontent }}</p>
    </div>

    <v-row class="d-none d-lg-flex justify-content-center desktop-design mt-5">
      <v-col
        v-bind:class="{ popular: popular, standard: !popular }"
        lg="3"
        v-for="(
          { popular, caption, title, price, services, subprice, link, soon }, index
        ) in items"
        :key="index"
      >
        <v-card class="card-container">
          <div v-if="popular" class="text-uppercase py-2">
            <h6 class="mb-0">{{ popular }}</h6>
          </div>
          <div class="container-main-text px-4 py-4">
            <div v-if="caption" class="caption text-left mr-5">
              <h4 class="mb-3">{{ caption }}</h4>
            </div>
            <h6 class="text-left">{{ title }}</h6>
            <h4 class="mt-4 text-center">{{ price }}</h4>
            <small>{{ subprice }}</small>
          </div>
          <v-list class="d-flex justify-content-center">
            <v-list-item-group :aria-label="title">
              <v-list-item
                v-for="({ info, type }, index) in services"
                :key="index"
                :aria-labelledby="text"
              >
                <v-list-item-icon v-if="type === 'icon'">
                  <v-icon dense>{{ info }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content v-if="type === 'label'">
                  <v-list-item-title v-text="info"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
        <base-button v-if="link" white shadow class="ml-4 btn-outline-primary" @click="$helpers.goToWebApp(link)">
          {{ hire_now }}
        </base-button>
        <base-button v-if="soon" white shadow class="ml-4">
          {{ soon_text }}
        </base-button>
      </v-col>
    </v-row>

    <v-row class="responsive-design mt-5 flex-column justify-center d-lg-none d-xs-flex">
     <h4 class="font-weight-bold">{{ $t('price-cards.table.title') }}</h4>
        <h6 class="font-weight-bold">{{ $t('price-cards.table.subtitle') }}</h6>
      <v-col
        v-bind:class="{ popular: popular, standard: !popular }"
        xs="12"
        v-for="(
          { popular, caption, title, price, services, subprice, link, soon }, index
        ) in items2"
        :key="index"
      >

        <v-card class="card-container">
          <div v-if="popular" class="text-uppercase py-2">
            <h6 class="mb-0">{{ popular }}</h6>
          </div>
          <div class="container-main-text px-4 py-4">
            <div v-if="caption" class="caption text-left mr-5">
              <h4 class="mb-3">{{ caption }}</h4>
            </div>
            <h6>{{ title }}</h6>
            <h4 class="mt-4">{{ price }}</h4>
            <small>{{ subprice }}</small>
          </div>
          <v-list class="d-flex justify-content-center">
            <v-list-item-group :aria-label="title">
              <v-list-item
                v-for="({ info, type }, index) in services"
                :key="index"
                :aria-labelledby="text"
              >
                <v-list-item-icon v-if="type === 'icon'">
                  <v-icon dense>{{ info }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content v-if="type === 'label'">
                  <v-list-item-title v-text="info"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
        <base-button v-if="link" white shadow class="ml-4 btn-outline-primary" @click="$helpers.goToWebApp(link)">
          {{ hire_now }}
        </base-button>
        <base-button v-if="soon" white shadow class="ml-4">
          {{ soon_text }}
        </base-button>
      </v-col>
    </v-row>
    <v-row >
      <v-col>
        <p class="mb-1">* {{ $t('price-cards.permanency') }}</p>
        <p class="m-0">** {{ $t('price-cards.family') }}</p>
      </v-col>
     </v-row>
  </section>
</template>
<script>
import es from '@/lang/es/public/views/primesalud.json'
import en from '@/lang/en/public/views/primesalud.json'

export default {
  name: 'primesalud-price-cards',
  i18n: {
    messages: {
      es,
      en,
      mx: es
    }
  },
  data () {
    return {
      items: [
        {
          caption: this.$t('price-cards.table.title'),
          title: this.$t('price-cards.table.subtitle'),
          services: [
            {
              info: this.$t('price-cards.table.wellness'),
              type: 'label'
            },
            {
              info: this.$t('price-cards.table.service-discounts'),
              type: 'label'
            },
            {
              info: this.$t('price-cards.table.online-family-medic'),
              type: 'label'
            },
            {
              info: this.$t('price-cards.table.online-pediatrics'),
              type: 'label'
            },
            {
              info: this.$t('price-cards.table.online-dermatology'),
              type: 'label'
            },
            {
              info: this.$t('price-cards.table.online-traumatology'),
              type: 'label'
            },
            {
              info: this.$t('price-cards.table.online-endocrinology'),
              type: 'label'
            }
          ]
        },
        {
          title: this.$t('price-cards.table.title1'),
          price: '14,95€',
          soon: true,
          subprice: `${this.$t('price-cards.table.per-month')}*`,
          services: [
            {
              info: 'mdi-check',
              type: 'icon'
            },
            {
              info: 'mdi-check',
              type: 'icon'
            },
            {
              info: 'mdi-check',
              type: 'icon'
            },
            {
              info: 'mdi-check',
              type: 'icon'
            },
            {
              info: 'mdi-check',
              type: 'icon'
            },
            {
              info: 'mdi-check',
              type: 'icon'
            },
            {
              info: 'mdi-check',
              type: 'icon'
            }
          ]
        },
        {
          popular: this.$t('price-cards.table.header'),
          title:
            this.$t('price-cards.table.title2'),
          price: '9,95€',
          link: 'opensalud360/prime?hire=prime',
          subprice: `${this.$t('price-cards.table.per-month')}*`,
          services: [
            {
              info: 'mdi-check',
              type: 'icon'
            },
            {
              info: 'mdi-check',
              type: 'icon'
            },
            {
              info: 'mdi-check',
              type: 'icon'
            },
            {
              info: 'mdi-check',
              type: 'icon'
            },
            {
              info: 'mdi-minus',
              type: 'icon'
            },
            {
              info: 'mdi-minus',
              type: 'icon'
            },
            {
              info: 'mdi-minus',
              type: 'icon'
            }
          ]
        },
        {
          title: this.$t('price-cards.table.title3'),
          price: '2,95€',
          link: 'opensalud360/prime?hire=wellwo',
          subprice: `${this.$t('price-cards.table.per-month')}*`,
          services: [
            {
              info: 'mdi-check',
              type: 'icon'
            },
            {
              info: 'mdi-check',
              type: 'icon'
            },
            {
              info: 'mdi-minus',
              type: 'icon'
            },
            {
              info: 'mdi-minus',
              type: 'icon'
            },
            {
              info: 'mdi-minus',
              type: 'icon'
            },
            {
              info: 'mdi-minus',
              type: 'icon'
            },
            {
              info: 'mdi-minus',
              type: 'icon'
            }
          ]
        }
      ],
      items2: [
        {
          title:
            this.$t('price-cards.table.title3'),
          price: '2,95€',
          link: 'opensalud360/prime?hire=wellwo',
          subprice: `${this.$t('price-cards.table.per-month')}*`,
          services: [
            {
              info: this.$t('price-cards.table.wellness'),
              type: 'label'
            },
            {
              info: this.$t('price-cards.table.service-discounts'),
              type: 'label'
            },
            {
              info: '-',
              type: 'label'
            },
            {
              info: '-',
              type: 'label'
            },
            {
              info: '-',
              type: 'label'
            },
            {
              info: '-',
              type: 'label'
            },
            {
              info: '-',
              type: 'label'
            }
          ]
        },
        {
          popular: this.$t('price-cards.table.header'),
          title:
            this.$t('price-cards.table.title2'),
          price: '9,95€',
          link: 'opensalud360/prime?hire=prime',
          subprice: `${this.$t('price-cards.table.per-month')}*`,
          services: [
            {
              info: this.$t('price-cards.table.wellness'),
              type: 'label'
            },
            {
              info: this.$t('price-cards.table.service-discounts'),
              type: 'label'
            },
            {
              info: this.$t('price-cards.table.online-family-medic'),
              type: 'label'
            },
            {
              info: this.$t('price-cards.table.online-pediatrics'),
              type: 'label'
            },
            {
              info: '-',
              type: 'label'
            },
            {
              info: '-',
              type: 'label'
            },
            {
              info: '-',
              type: 'label'
            }
          ]
        },
        {
          title: this.$t('price-cards.table.title1'),
          price: '14,95€',
          soon: true,
          subprice: `${this.$t('price-cards.table.per-month')}*`,
          services: [
            {
              info: this.$t('price-cards.table.wellness'),
              type: 'label'
            },
            {
              info: this.$t('price-cards.table.service-discounts'),
              type: 'label'
            },
            {
              info: this.$t('price-cards.table.online-family-medic'),
              type: 'label'
            },
            {
              info: this.$t('price-cards.table.online-pediatrics'),
              type: 'label'
            },
            {
              info: this.$t('price-cards.table.online-dermatology'),
              type: 'label'
            },
            {
              info: this.$t('price-cards.table.online-traumatology'),
              type: 'label'
            },
            {
              info: this.$t('price-cards.table.online-endocrinology'),
              type: 'label'
            }
          ]
        }
      ]
    }
  },
  props: {
    title: {
      type: String,
      default () {
        return this.$t('price-cards.title')
      }
    },
    subtitle: {
      type: String,
      default () {
        return this.$t('price-cards.subtitle')
      }
    },
    content: {
      type: String,
      default () {
        return this.$t('price-cards.content')
      }
    },
    subcontent: {
      type: String,
      default () {
        return this.$t('price-cards.subcontent')
      }
    },
    hire_now: {
      type: String,
      default () {
        return this.$t('price-cards.hire')
      }
    },
    soon_text: {
      type: String,
      default () {
        return this.$t('price-cards.soon')
      }
    }
  }
}
</script>
<style lang="scss">
section.open-salud-prices {
  min-height: 100vh;
  background-color: #fff;
}

.open-salud-prices p.subtitle {
  color: #2f35c3;
  font-size: 1.5rem;
  margin: auto;
  text-align: initial;
  line-height: 1.2;
  text-align: center;
}
.open-salud-prices .main-text {
  text-align: center;
  font-size: 1.25rem;
  margin: auto;
  text-align: center;
}

.v-list-item {
  border-bottom: 1px solid #ebebeb;
  padding: 8px 16px;
  height: 77px;
  display: flex;
  align-items: center;
  justify-content: center;
  .mdi-check {
    color: #3238c4;
  }
}

.open-salud-prices h3 {
  font-size: 4rem;
  margin: auto;
  text-align: initial;
  margin-bottom: 1rem;
  text-align: center;
}

.open-salud-prices .popular .card-container > div:first-child {
  text-align: center;
  background-color: #3238c4;
  color: white;
  padding: 1px;
}
.open-salud-prices .popular .card-container {
  box-shadow: 0 0 15px #0003;
  margin: 1rem;
}
.open-salud-prices .standard .card-container {
  box-shadow: none;
}
.open-salud-prices .standard .card-container:nth-child(2) {
  margin-top: 2rem;
}

.col-lg-3.col.standard {
  margin-top: 4rem;
}

.col-md-3:nth-child(n + 2) {
  max-width: 20%;
}

.v-list-item-group {
  width: 80%;
}

.open-salud-prices .btn-container {
  border-top: 1px solid #a2a2a2;
}
.open-salud-prices .text-button {
  margin-top: 1.5rem;
}

@media (max-width: 1268px) {
  .open-salud-prices h3 {
    width: 100%;
    padding: 0 1rem;
  }
  .open-salud-prices .subtitle {
    width: 100%;
    padding: 0 1rem;
  }
  .open-salud-prices .main-text {
    width: 100%;
    padding: 0 1rem;
  }
}
@media (max-width: 960px) {

.open-salud-prices .standard .card-container {
  box-shadow: 0 0 15px #0003;
  margin: 1rem;
}
  .open-salud-prices h3 {
    font-size: 2.5rem;
    margin-top: 0;
  }
  .open-salud-prices h3 {
    width: 100%;
    padding: 0.2rem;
  }

  .col-md-3:nth-child(n + 2) {
    max-width: 100%;
  }

  #primesalud-price-cards > div.container > div > div.popular > div {
    margin: 0 auto;
  }

  .open-salud-prices .responsive-design .standard .v-card .v-list-item .v-list-item__content div,
  .open-salud-prices .responsive-design .popular .v-card .v-list-item__content div.v-list-item__title{
    white-space: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/PrimesaludPriceCards.vue